var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFFFFF",
    viewBox: "0 0 24 24",
    className: "icon-camera"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#69d5b1",
    d: "M6.59 6l2.7-2.7A1 1 0 0 1 10 3h4a1 1 0 0 1 .7.3L17.42 6H20a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h2.59zM19 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-7 8a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#179a6f",
    d: "M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
  })));
}

export default SvgCamera;